module.exports = __webpack_public_path__ + "9eb54136345c1b7e0f0c77fb5b64eb.svg";